import { Facebook, Instagram, LinkedIn, X } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { grey } from '@mui/material/colors';

type SocialLinkType = 'linkedin' | 'instagram' | 'twitter' | 'facebook';
interface SocialLinkProps {
  type: SocialLinkType;
  href: string;
}
export const SocialLink = ({ type, href }: SocialLinkProps) => {
  const cleaned = (href || '').split(';')[0];
  const disabled = !href || href.indexOf('***') > -1;
  const color = {
    disabled: 'grey',
    instagram: '#e4405f',
    linkedin: '#0077b5',
    twitter: '#1da1f2',
    facebook: '#1877f2',
  }[type];
  return (
    <Tooltip title={cleaned} placement="top">
      <IconButton
        href={href}
        aria-label={`${type} link`}
        target="_blank"
        rel="noopener nofollow"
        sx={{
          color: disabled ? grey[200] : color,
        }}>
        {type === 'twitter' && <X />}
        {type === 'linkedin' && <LinkedIn />}
        {type === 'instagram' && <Instagram />}
        {type === 'facebook' && <Facebook />}
      </IconButton>
    </Tooltip>
  );
};
